import { useState } from "react";
import { toast } from "react-toastify";
import { UPDATE_PACK } from "./quantity-counter";
import { useMutation } from "@apollo/client";
import { notify, notifyError } from "../../../../utils/toast";
import * as Sentry from "@sentry/react";

const PriceCounter = ({
  price,
  discountRate: initialDiscountRate,
}: {
  price: number;
  discountRate: number;
}) => {
  const discountRate = initialDiscountRate ?? 0.6;
  const [count, setCount] = useState(price);
  const [isEditing, setIsEditing] = useState(false);
  const [updatePack] = useMutation(UPDATE_PACK);
  const handleSubmit = () => {
    updatePack({
      variables: {
        price: count,
        discountPrice: Math.floor(count * discountRate),
        userPrice: Math.floor(count * discountRate + 900),
      },
      onCompleted: () => {
        notify("팩 가격이 저장되었습니다.");
        setIsEditing(false);
      },
      onError: (error) => {
        notifyError("에러가 발생했습니다. 지속될 경우 고객센터 문의 바랍니다.");
        setIsEditing(false);
        Sentry.captureException(error);
      },
    });
  };
  return (
    <>
      <div className="flex flex-col justify-center mt-6 w-full">
        <h3 className="text-3xl font-bold mt-4 text-gray-800">팩 가격 설정</h3>
        <div className="flex flex-col justify-center gap-2 mt-6 bg-white rounded-lg p-4 pt-6 shadow-md">
          <div className="flex items-center justify-center">
            <button
              className="bg-gray-300 w-10 h-10 font-bold rounded-full text-2xl mr-2"
              onClick={() => {
                setIsEditing(true);
                setCount(count - 200);
              }}
            >
              -
            </button>
            <span className="relative">
              <span className="absolute left-0 top-1/2 -translate-y-1/2 text-gray-700">
                ₩
              </span>
              <input
                type="number"
                className="w-32 h-12 text-center py-2 rounded-lg focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition duration-200 text-4xl font-bold placeholder:text-sm"
                value={count}
                onChange={(e) => {
                  setIsEditing(true);
                  if (parseInt(e.target.value) <= 0) {
                    toast.error("가격은 0원 이하가 될 수 없어요!");
                  } else {
                    setCount(parseInt(e.target.value));
                  }
                }}
                placeholder="가격을 입력해주세요"
              />
            </span>
            <button
              className="bg-blue-400 w-10 h-10 font-bold rounded-full text-2xl"
              onClick={() => {
                setIsEditing(true);
                setCount(count + 200);
              }}
            >
              +
            </button>
          </div>
          <div className="flex justify-center">
            <p className="text-gray-500 text-lg mt-0.5">
              *클릭하여 가격 직접 입력 가능
            </p>
          </div>
          <button
            className={`bg-blue-500 text-white px-4 py-2 rounded-2xl mt-4 inline-block ${
              !isEditing ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={handleSubmit}
            disabled={!isEditing}
          >
            적용하기
          </button>
        </div>

        <div className="flex flex-col gap-2 mt-4 text-xl">
          <div className="flex items-center justify-between p-3 bg-white rounded-lg shadow-sm">
            <span className="text-gray-700 font-medium">정산 금액</span>
            <span className="font-bold text-lg text-[#1562fc]">
              {count > 0
                ? Math.floor(count * discountRate).toLocaleString()
                : "0"}
              원
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PriceCounter;
